import axios, { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { logger } from './logger';

declare module 'axios' {
  export interface InternalAxiosRequestConfig {
    metadata?: { startTime: number };
  }
}

export const setupApiLogging = () => {
  axios.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const startTime = Date.now();

      config.metadata = { startTime };

      logger.logApiCall({
        method: config.method,
        url: config.url,
        data: config.data,
        params: config.params,
        headers: config.headers,
      });

      return config;
    },
    (error: AxiosError) => {
      logger.error('Request interceptor error', 'API', error);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      const { config } = response;
      const endTime = Date.now();
      const duration = endTime - (config.metadata?.startTime || endTime);

      logger.logApiResponse({
        status: response.status,
        config: {
          method: config.method,
          url: config.url,
        },
        duration,
      });

      if (duration > 5000) {
        logger.warn(
          `Slow API response detected: ${config.method?.toUpperCase()} ${config.url} took ${duration}ms`,
          'Performance',
          { duration, url: config.url }
        );
      }

      return response;
    },
    (error: AxiosError) => {
      const endTime = Date.now();
      const duration = endTime - (error.config?.metadata?.startTime || endTime);

      logger.logApiError({
        ...error,
        duration,
      });

      return Promise.reject(error);
    }
  );
};
